<template>
  <div id="cc-product-filter-panel">
    <b-form-group class="mt-3">
      <b-form-input
        id="search-products"
        placeholder="Search"
        class="pl-5 py-3 border-0"
        v-model="product_keyword"
        :disabled="!selectedBranch"
        @keyup.native="searchProducts">
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  computed: {
    ...mapGetters({
      selectedBranch: "conversationalCommerce/selectedBranch",
      selectedBrand: "conversationalCommerce/selectedBrand",
      selectedCategory: "conversationalCommerce/selectedCategory"
    }),
    ...mapFields("conversationalCommerce", ["product_keyword"])
  },
  created() {
    this.searchProducts = _.debounce(() => {
      this.$store.dispatch("conversationalCommerce/getBranchProducts");
    }, 300);
  },
  methods: {
    resetSearchKeyword() {
      this.product_keyword = null;
    }
  },
  watch: {
    selectedBrand() {
      this.resetSearchKeyword();
    },
    selectedBranch() {
      this.resetSearchKeyword();
    }
  }
}
</script>

<style lang="scss" scoped>
#cc-product-filter-panel {
  #search-products {
    border-radius: 38px;
    background: #F6F9FC url('~@/assets/images/search.svg') no-repeat center left 10px;
    font-size: 16px;
    &::placeholder {
      color: #87929D;
    }
  }
}
</style>
